module.exports = __webpack_public_path__ + "img/1534540537.28a0398a.jpg";